import { db } from "../firebaseConfig";
import { doc, setDoc, getDoc } from "firebase/firestore";

const getSetting = (name) => {
  const docRef = doc(db, "setting", name);
  return getDoc(docRef).then((doc) => {
    if (doc.exists) {
      return doc.data();
    } else {
      return {};
    }
  });
};

const updateSetting = (name, data) => {
  return setDoc(doc(db, "setting", name), data, { merge: true });
};

export default { getSetting, updateSetting };
